module.exports = __webpack_public_path__ + "static/media/mybb-img1.2a828a9b.svg";